import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { Button } from '@components';
import { toast } from 'react-toastify';
import { RequerimentoService } from '../../../../../common/services/requerimento';

const AnexoPendenteModal = ({ requerimento }) => {
  const user = useSelector((state) => state.user);
  const formularios = useSelector((state) => state.requerimento.allFormsLabels);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const formObj = formularios.find((valor) => {
    return valor.referencia === requerimento.Formulario;
  });

  function baixarArquivoPDF(protocolo) {
    try {
      const service = new RequerimentoService();
      setLoadingPDF(true);
      service
        .gerarPDFRequerimento({
          matricula: user.matricula,
          protocolo,
          token: user.token,
        })
        .then((res) => {
          const blob = new Blob([res], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Requerimento - ${protocolo}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setLoadingPDF(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar o PDF do requerimento`);
    }
  }

  return formObj ? (
    <div className="card mb-4">
      <div className="card-body card-desktop">
        <div>
          <Button
            onClick={() => baixarArquivoPDF(requerimento.Protocolo)}
            disabled={loadingPDF}
            className="simpleLink ts-14"
          >
            {loadingPDF ? 'Carregando...' : `Nº:${requerimento.Protocolo}`}
          </Button>
          <h1 className="ts-20 fw-bold">{formObj.nome}</h1>
        </div>
        <div>
          <p className="text-muted ts-14 text-nowrap">Solicitado em</p>
          <p className="ts-14 fw-bold">
            {format(new Date(requerimento.DataCriacao), 'dd/MM/yyyy')}
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

export const PageBody = () => {
  const emAndamento = useSelector(
    (state) => state.requerimento['em andamento']
  );

  return (
    <>
      {emAndamento.map((requerimento) => (
        <AnexoPendenteModal
          requerimento={requerimento}
          key={requerimento.Protocolo + requerimento.DataCriacao}
        />
      ))}
      {emAndamento.length === 0 && (
        <div className="card">
          <div className="card-body">
            <p>Você não possui requerimentos em andamento</p>
          </div>
        </div>
      )}
    </>
  );
};
